<template>
	<div class=" animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1" @click="link('/userHome')">当前位置：账户总览</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">通知详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回上一页</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 消息列表 -->
		<div class="newsList">
			<div class="t1">{{pagemsg.noticeTitle}}</div>
			<div class="t2">发布日期：{{gsTime(pagemsg.createTime)}}</div>
			<div class="t3"  v-html="pagemsg.noticeContent">
				
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { noticeDetail,
messagecompanyMessageList,
messagememberReadAll,
messagecompanyReadAll,
messagememberDeleteAll,
messagecompanyDeleteAll,
messagecompanyRead,
messagememberRead,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			pagemsg:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 消息列表
			messageArr:[],
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		this.messageListGet(1)
	},
	methods:{
		// 查询消息列表
		async messageListGet(def){
			const res = await noticeDetail({noticeId:this.id});
			if(res.code==200){
				this.pagemsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.messageListGet()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
			cursor: pointer;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.newsList{
	margin: 0 40px;
	background: #fff;
	padding: 32px;
	border-radius: 0 0 20px 20px;
	.t1{
		font-size: 24px;
		text-align: center;
		padding-top: 20px;
	}
	.t2{
		font-size: 16px;
		color: #999999;
		text-align: center;
		margin-top: 18px;
		padding-bottom: 30px;
		border-bottom: 1px solid #EEEEEE;
	}
	.t3{
		font-size: 16px;
		padding: 24px 0;
	}
	
	
	.newsTit{
		height: 84px;
		border-radius: 20px 20px 0 0;
		background: #3B6492;
		padding-left: 24px;
		padding-right: 30px;
		.txt{
			.el-image{
				width: 40px;
				height: 40px;
				margin-right: 12px;
			}
			.t2{
				font-size: 18px;
				font-weight: bold;
				color: #fff;
			}
		}
		.anniu{
			div{
				border-radius: 8px;
				padding: 0 15px;
				height: 36px;
				line-height: 36px;
				background: #fff;
				margin-left: 12px;
				font-size: 14px;
				cursor: pointer;
			}
			.t1{
				color: #3B6492;
			}
			.t2{
				color: #FF5F5A;
			}
		}
	}
	.newsListBox{
		margin: 0 24px;
	}
	.newsItm{
		// height: 100px;
		border-bottom: 1px solid #DDDDDD;
		padding: 20px 0;
		.newTit{
			.l{
				.bor{
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin-right: 8px;
					background: #F26161;
				}
				span{
					font-size: 18px;
					// color: #333333;
				}
			}
			.r{
				font-size: 16px;
				color: #999999;
			}
		}
		.newTxt{
			color: #666666;
			font-size: 16px;
			margin-top: 14px;
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-bottom: 28px;
	margin-top: 30px;
	.i1{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	.fyitm{
		width: 32px;
		height: 32px;
		font-size: 12px;
		text-align: center;
		line-height: 32px;
		margin-right: 6px;
		border-radius: 4px;
	}
	.a{
		background: #3B6492;
		color: #fff;
	}
	.i2{
		width: 24px;
		height: 24px;
		margin-right: 19px;
	}
	.linkPage{
		p{
			font-size: 12px;
		}
		.ipt{
			margin: 0 6px;
			width: 42px;
			height: 32px;
			border-radius: 4px;
			background: #F4F4F4;
			.el-select{
				width: 100%;
			}
			::v-deep .el-input__inner{
				border: none;
				background: transparent;
			}
		}
	}
}
</style>